import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
import { Button } from "./button.js";
/** "8.968", e não "8968" — o milhar que o balcão lê (F248). */
const count = (value) => value.toLocaleString('pt-BR');
/**
 * Paginação e contagem de uma lista — F132.
 *
 * Existiam nove cópias à mão da mesma `<nav aria-label="Paginação">`, e uma
 * delas (Chamados) já tinha derivado: 20 por página, botões fantasma, "2/5". A
 * lista que a pessoa usa não pode mudar de cara ao trocar de módulo.
 *
 * O servidor pagina; isto só desenha. `page` começa em 1.
 */
const lastPageOf = (total, pageSize) => Math.max(1, Math.ceil(total / Math.max(1, pageSize)));
export const Pagination = ({ page, pageSize, total, onPageChange, label = 'Paginação', className, }) => {
    const lastPage = lastPageOf(total, pageSize);
    // Uma página só não precisa de navegação: dois botões desabilitados são
    // ruído que parece defeito.
    if (lastPage <= 1)
        return null;
    return (_jsxs("nav", { "aria-label": label, className: cn('flex items-center justify-end gap-2', className), children: [_jsx(Button, { variant: "secondary", size: "sm", disabled: page <= 1, onClick: () => {
                    onPageChange(Math.max(1, page - 1));
                }, children: "Anterior" }), _jsxs("span", { className: "text-(length:--text-xs) text-(--text-muted)", children: ["P\u00E1gina ", count(page), " de ", count(lastPage)] }), _jsx(Button, { variant: "secondary", size: "sm", disabled: page >= lastPage, onClick: () => {
                    onPageChange(Math.min(lastPage, page + 1));
                }, children: "Pr\u00F3xima" })] }));
};
/**
 * "Mostrando 26–50 de 312", anunciado.
 *
 * `aria-live` para quem usa leitor de tela ouvir a contagem mudar em vez de só
 * perceber a tabela redesenhar.
 */
export const ResultCount = ({ page, pageSize, total, loading = false, none, className, }) => {
    const first = (page - 1) * pageSize + 1;
    const last = Math.min(page * pageSize, total);
    return (_jsx("p", { "aria-live": "polite", className: cn('text-(length:--text-xs) text-(--text-muted)', className), children: loading
            ? 'Carregando…'
            : total === 0
                ? none
                : `Mostrando ${count(first)}–${count(last)} de ${count(total)}` }));
};
//# sourceMappingURL=pagination.js.map